.trust {
  display: flex;
  align-items: center;
  justify-content: center;
  flex-wrap: wrap;
  gap: 10px;
}

.trust__label {
  font-size: 15px;
  font-weight: 700;
  color: var(--color-primary-grey-900); /* PRIMARY_GREY_900 */
}

.trust__stars {
  display: flex;
  gap: 3px;
}

.trust__star {
  width: 26px;
  height: 26px;
  border-radius: 3px;
  background: #00b67a; /* HACK: Trustpilot brand green — a third-party colour, no DS token */
  color: var(--color-primary-grey-000); /* PRIMARY_GREY_000 */
  display: inline-flex;
  align-items: center;
  justify-content: center;
}

.trust__star svg {
  width: 16px;
  height: 16px;
  display: block;
}

.trust__link {
  display: inline-flex;
  align-items: center;
  gap: 5px;
  font-size: 15px;
  font-weight: 700;
  color: var(--color-primary-grey-900); /* PRIMARY_GREY_900 */
}

.trust__logoStar {
  display: inline-flex;
  color: #00b67a; /* HACK: Trustpilot brand green — a third-party colour, no DS token */
}

.trust__logoStar svg {
  width: 18px;
  height: 18px;
  display: block;
}
